import { useQuery } from "react-query";
import { useClient } from "hooks";

export const useUserActionsQuery = (config) => {
  const client = useClient();

  return useQuery({
    queryKey: ["user_wp_connect_actions"],
    queryFn: async () => client.get("user_wp_connect_actions").get("data"),
    ...config,
  });
};
